import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { RTLConnector } from './icons/RtlStyledConnector';
import {StepLabel } from '@mui/material';
import { Hidden } from '@mui/material';
import CompleteInfo from './icons/CompleteInfo';
import Pay from './icons/Pay';
import Sign from './icons/Ekyc';
import Keys from './icons/Keys';
import GetCsr from './icons/GetCsr';
import { useSelector } from 'react-redux';
import Payment from '../Payment';
import KeysMainPage from '../keys/KeysMainPage';
import CreateCsr from '../getCertification/CreateCsr';
import { Toaster } from 'react-hot-toast';
import EkycPage from '../ekyc/Ekyc';
import Completed from './icons/Completed';
import CompanyInfo from "./icons/CompanyInfo";
import CompleteUserInfo from "../../complete_info/CompeleteUserInfo";
import CompletedCompanyInfo from "../../complete_info/company_info";

const icons = [
    // <FirstInfo />,
    <Pay />,
    <CompanyInfo />,
    <CompleteInfo />,
    <Sign />,
    <Keys />,
    <GetCsr />
];

const stepperStyle = {
    "& .Mui-active svg":{
        stroke: "#0BA9B5",
    },
    // "& .Mui-completed svg":{
    //   stroke: "#0BA9B5",
    //   // fill : "#0BA9B5"
    // },
    '& .MuiStepLabel-label':
        {
            fontFamily: 'IRANYekanX',
            fontSize: "80%"
        },
    '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
        {
            color: '#0BA9B5', // Just text label (COMPLETED)
        },
    '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel': {
        color: '#0BA9B5',
    }
}

const lables = [
    // "اطلاعات اولیه",
    "پرداخت",
    "اطلاعات سازمان",
    "اطلاعات نماینده",
    "احراز هویت",
    "کلید ها",
    "دریافت گواهی",
];


export default function StepperMenuCompany() {

    const activeStep = useSelector( state => state.Stepper)

    function getSectionComponent() {
        switch(activeStep) {
            case 0: return <Payment/>;
            case 1: return <CompletedCompanyInfo/>;
            case 2: return <CompleteUserInfo/>;
            case 3: return <EkycPage/>;
            case 4: return <KeysMainPage/>;
            case 5: return <CreateCsr/>;
            default: return null;
        }
    }

    function getPropsIcon(props) {

        const completed = props.completed

        switch(props.icon) {
            case 1: return completed ? <Completed/> : <Pay/>;
            case 2: return completed ? <Completed/> : <CompanyInfo/>;
            case 3: return completed ? <Completed/> : <CompleteInfo/>;
            case 4: return completed ? <Completed/> : <Sign/>;
            case 5: return completed ? <Completed/> : <Keys/>;
            case 6: return completed ? <Completed/> : <GetCsr/>;
            default: return null;
        }

    }

    return (
        <>
            <Toaster/>
            <Box sx={{ width: '100%' }}>

                <Hidden  mdDown>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        connector={<RTLConnector />}
                        sx={stepperStyle}
                    >
                        {icons.map((icon_show, index) => (
                            <Step key={index}>
                                <StepLabel StepIconComponent={getPropsIcon} >{lables[index]}</StepLabel>
                            </Step>

                        ))}
                    </Stepper>
                </Hidden>

                <Hidden mdUp>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        connector={<RTLConnector />}
                        sx={stepperStyle}
                    >
                        {icons.map((icon_show, index) => (
                            <Step key={index}>
                                <StepLabel StepIconComponent={getPropsIcon} ></StepLabel>
                            </Step>

                        ))}
                    </Stepper>
                </Hidden>

            </Box>

            <div>
                {getSectionComponent()}
            </div>
        </>

    );
}